{
  "version": 1,
  "asset_id": "98312eab-2168-4d7a-a366-f8616b03f1b8",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/98312eab-2168-4d7a-a366-f8616b03f1b8/ind-saas-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/98312eab-2168-4d7a-a366-f8616b03f1b8/ind-saas-1200.avif",
  "original_filename": "ind-saas-1200.avif",
  "size": 12403,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:15Z"
}
